// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPageLayout-cls1_cVw","cls2":"MarketingPageLayout-cls2_4Gi MarketingPageLayout-cls1_cVw"};